import React from 'react'

interface IDeleteCribSheetPopup {
    onClose: () => void;
    onDelete: () => void
}

const DeleteCribSheetPopup = (props: IDeleteCribSheetPopup) => {
    return (
        <div className="lcs-modal-overlay">
            <div className="lcs-modal">
                <button className="lcs-modal__close" onClick={props.onClose}>
                    <img src='/assets/images/dismiss.svg' alt='close' />
                </button>

                <div className="lcs-modal__icon">
                    <img src="/assets/images/trash-red-icon.svg" alt="" width="48" height="48" />
                </div>
                <h2 className="lcs-modal__title">Delete Crib Sheet</h2>
                <p className="lcs-modal__desc">Are you sure you want to delete crib sheet?</p>

                <div className="lcs-modal__buttons">
                    <button className="lcs-modal__btn lcs-modal__btn--cancel" onClick={props.onClose}>
                        No, Keep Crib Sheet
                    </button>
                    <button className="lcs-modal__btn lcs-modal__btn--delete" onClick={props.onDelete}>
                        Yes, Delete Crib Sheet
                    </button>
                </div>
            </div>
        </div>
    )
}

export default DeleteCribSheetPopup